import React, { useState } from "react";
import styles from "../TagDialog.module.css";
import { translate } from "../../../../../common/providers";
import { CustomDialog, CustomTextField } from "../../../../../common/components";

const NewTagDialog = ({ open, close, onCreateNewTag }) => {
	const [name, setName] = useState("");
	const changeName = (value) => {
		setName(value);
	};
	const handleCloseAndAction = () => {
		onCreateNewTag(name);
		close();
	};
	return (
		<CustomDialog
			displayCloseCross
			isForm
			open={open}
			title={translate("qa-journal.qa-actions.new-tag-dialog.title")}
			onClose={close}
			onSubmit={handleCloseAndAction}
		>
			<div className={`${styles["margin-bottom"]} ${styles["padding-top"]}`} style={{ display: "flex" }}>
				<CustomTextField
					fullWidth
					required
					className={styles["dialog__name-field"]}
					label={translate("qa-journal.qa-actions.new-tag-dialog.texfield-label")}
					size="small"
					variant="outlined"
					onChange={(e) => changeName(e.target.value)}
				/>
			</div>
		</CustomDialog>
	);
};
export default NewTagDialog;
